export default function CannonFortsIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none" strokeLinecap="round">
      <path d="M14 34C22 12 42 8 52 26" stroke="#E7ECF3" strokeWidth="2.5" strokeDasharray="1 5" />
      <circle cx="52" cy="27" r="4" fill="#E7ECF3" />
      <path d="M2 58V48h12c8 0 12-10 18-10s10 10 18 10h12v10z" fill="#3B434F" />
      <rect x="4" y="38" width="14" height="10" rx="1.5" fill="#2F8BFF" />
      <path d="M4 38v-4h4v4M14 38v-4h4v4" fill="#2F8BFF" />
      <rect x="46" y="38" width="14" height="10" rx="1.5" fill="#FF8A1F" />
      <path d="M46 38v-4h4v4M56 38v-4h4v4" fill="#FF8A1F" />
      <path d="M11 34l8-8" stroke="#E7ECF3" strokeWidth="5" />
    </svg>
  );
}
